<template>
  <section
    class="section-pay w-full max-w-[1600px] mx-auto px-140 flex justify-between min-h-607 pt-120"
  >
    <div class="section-pay-right mr-100 w-1/2">
      <img src="../assets/home_23_1.png" alt="changjing" class="w-full h-500 object-scale-down" />
    </div>
    <div class="section-pay-left text-left pt-50 w-1/2">
      <p class="text-1xl text-black mb-20">{{ $t('lang.secure1') }}</p>
      <p class="text-black mb-10 font-bold" style="font-size: 45px;">{{ $t('lang.secure2') }}</p>
      <p class="mb-80 text-[#FF7800] font-[500]" style="font-size: 22px;">
        <span class="text-2xl mr-5 font-bold">——</span>
        {{ $t('lang.secure3') }}
      </p>
      <p class="text-sm text-black">{{ $t('lang.secure4') }}</p>

      <div class="mt-40">
        <div class="flex w-500 items-top mb-30">
          <div class="w-8 h-8 bg-[#FF7800] rounded-full mr-10 mt-5"></div>
          <p class="text-sm text-black ml-10 w-full word-break">{{ $t('lang.secure5') }}</p>
        </div>
        <div class="flex w-500 items-top mb-30">
          <div class="w-8 h-8 bg-[#FF7800] rounded-full mr-10 mt-5"></div>
          <p class="text-sm text-black ml-10 w-full word-break">{{ $t('lang.secure6') }}</p>
        </div>
        <div class="flex w-500 items-top mb-30">
          <div class="w-8 h-8 bg-[#FF7800] rounded-full mr-10 mt-5"></div>
          <p class="text-sm text-black ml-10 w-full word-break">{{ $t('lang.secure7') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "sectionPay",

  data() {
    return {};
  },

  mounted() {},

  methods: {}
};
</script>